import { Helmet } from "react-helmet";

export default function SEO({
    title = "Risk Markets | Real-Time Decision-Based Trading",
    description = "Test your nerve and market intuition. Watch the growth factor climb in real-time and decide exactly when to lock in your gains before the scenario terminates. High-speed financial decision-making built on Rain Protocol.",
    image = "/preview.png",
    url = "/preview.png",
}) {

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />

            {/* Open Graph */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={image} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {/* Optional debug meta to verify */}
            <meta name="seo-component-debug" content="true" />
        </Helmet>
    );
}
